module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "m-nav",
    class: {
      'close-nav': _vm.close
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/appointments/modal"
    }
  }, [_c('i', {
    staticClass: "fas fa-tty no-print"
  })]), _vm._v(" "), _c('h1', [(_vm.$route.name === 'appointmentindex') ? [_c('i', {
    staticClass: "fa fa-car"
  })] : void 0, _vm._v(" "), (_vm.$route.name === 'familyindex') ? [_c('i', {
    staticClass: "fa fa-home"
  })] : void 0, _vm._v(" "), (_vm.$route.name === 'studentindex') ? [(_vm.student.gender === 1) ? [_c('i', {
    staticClass: "fa fa-user-circle man"
  })] : _vm._e(), _vm._v(" "), (_vm.student.gender === 2) ? [_c('i', {
    staticClass: "fa fa-user-circle woman"
  })] : _vm._e()] : void 0, _vm._v(" "), (_vm.$route.name === 'tutorindex') ? [(_vm.tutor.gender === 0) ? [_c('i', {
    staticClass: "fa fa-graduation-cap"
  })] : _vm._e(), _vm._v(" "), (_vm.tutor.gender === 1) ? [_c('i', {
    staticClass: "fa fa-graduation-cap man"
  })] : _vm._e(), _vm._v(" "), (_vm.tutor.gender === 2) ? [_c('i', {
    staticClass: "fa fa-graduation-cap woman"
  })] : _vm._e()] : void 0, _vm._v("\n\n    " + _vm._s(_vm.pageTitle) + "\n  ")], 2), _vm._v(" "), _c('div', {
    staticClass: "m-nav__action"
  }, [_c('ul', [_c('li', {
    staticClass: "m-nav__action__layout no-print"
  }, [_c('a', {
    class: {
      'layout': this.$store.state.layout === 'left'
    },
    on: {
      "click": function($event) {
        return _vm.changeLayout('left')
      }
    }
  }), _vm._v(" "), _c('a', {
    class: {
      'layout': this.$store.state.layout === 'split'
    },
    on: {
      "click": function($event) {
        return _vm.changeLayout('split')
      }
    }
  }), _vm._v(" "), _c('a', {
    class: {
      'layout': this.$store.state.layout === 'right'
    },
    on: {
      "click": function($event) {
        return _vm.changeLayout('right')
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    attrs: {
      "href": "http://neo-help.masterminds.jp/history",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "title": "変更履歴"
    },
    on: {
      "click": _vm.checkUpdate
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "no-print"
  }, [_c('router-link', {
    attrs: {
      "to": "/appointments/calendar",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-alt",
    attrs: {
      "title": "APカレンダー"
    }
  })])], 1), _vm._v(" "), (_vm.$route.name === 'appointmentindex') ? [_c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.deleteAppointment(_vm.appointment)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v("AP削除")])])] : _vm._e(), _vm._v(" "), (_vm.$route.name === 'familyindex') ? [_c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.deleteFamily(_vm.family)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v("家庭削除")])])] : _vm._e(), _vm._v(" "), (_vm.$route.name === 'studentindex') ? [_c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.deleteStudent(_vm.student)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v("生徒削除")])])] : _vm._e(), _vm._v(" "), (_vm.$route.name === 'tutorindex') ? [_c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.deleteTutor(_vm.tutor)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v("先生削除")])])] : _vm._e(), _vm._v(" "), (_vm.$route.name === 'agreementindex') ? [_c('li', {
    staticClass: "no-print"
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.deleteAgreement(_vm.agreement)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v("契約削除")])])] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "m-nav__action__logout no-print"
  }, [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("Log out")])]), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "type no-print"
  }, [_c('a', [_vm._v(_vm._s(_vm.user.type))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "user-icon no-print"
  }, [_c('a', [_vm._v(_vm._s(_vm.officeName))])]), _vm._v(" "), _c('li', {
    staticClass: "user-icon no-print"
  }, [_c('a', [_vm._v(_vm._s(_vm.userName))])])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c5adb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/common/TopNavi.vue
// module id = 1362
// module chunks = 0